import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import CookiePolicy from "./Component/CookiePolicy";
import {
  AccessibilityStatement,
  AcceptableUsePolicy,
  CommunicationsPolicy,
  IntellectualPropertyPolicy,
  LegalNotice,
  OrdersPolicy,
  PaymentsPolicy,
  PolicyCenter,
  PricingPolicy,
  PrivacyChoices,
  ProductSafetyPolicy,
  PromotionsPolicy,
  ReviewsPolicy,
  SecurityPolicy,
  WarrantyPolicy,
} from "./Component/StorePolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-choices" element={<PrivacyChoices />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route path="/orders" element={<OrdersPolicy />} />
          <Route path="/payments" element={<PaymentsPolicy />} />
          <Route path="/pricing" element={<PricingPolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/product-safety" element={<ProductSafetyPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/reviews-policy" element={<ReviewsPolicy />} />
          <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/security" element={<SecurityPolicy />} />
          <Route path="/communications" element={<CommunicationsPolicy />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
